<span id="feedback-screend-reader" class="only-screen-reader" 
[ngClass]="{'hidden': hideStatusResult}" aria-live="assertive" aria-atomic="true">
  {{statusResult}}
</span>
<ion-item class="line2">
  <input
    #inputCurrency
    class="align-income__input"
    [id]="idIncome"
    maxLength="20"
    type="tel"
    role="textbox"
    name="income"
    tabindex="0"
    autocomplete="off"
    [value]="inputTextValue | currencyCustom"
    [attr.placeholder]="inputTextValue === '' ? placeholder : ''"
    [attr.aria-label]="label"
    (blur)="hideStatusResult = true;"
    (input)="updateValue($event)"
    (keyup.enter)="submitInput()"
    (keydown)="setStatusResult($event)"
    (drop)="false"
    (paste)="false"
    [disabled]="disabled"
    />
</ion-item>